import { spinnerCss } from 'components/Spinner'
import { css } from 'styled-components'

export type FetchingStyle = 'stripe' | 'spinner'

const stripeStyle = css`
  --stripe-pulse-color: ${({ theme }) => theme.colors.blue2};
  --stripe-bg-color: ${({ theme }) => theme.colors.blue5};

  left: 0;
  top: 1px;
  height: 3px;
  width: 100%;

  background: repeating-linear-gradient(
    145deg,
    var(--stripe-pulse-color),
    var(--stripe-pulse-color) 20px,
    var(--stripe-bg-color) 20px,
    var(--stripe-bg-color) 40px
  );
  background-size: 200% 200%;
  animation: barberpole 10s linear infinite;

  @keyframes barberpole {
    0% {
      background-position: 100% 100%;
    }
    100% {
      background-position: 0% 0%;
    }
  }
`

const spinnerStyle = css`
  bottom: 0.5rem;
  right: 0.5rem;
  height: 2rem;
  width: 2rem;
  ${spinnerCss}
`

export const renderFetching = css<{ isFetching?: boolean; fetchingStyle?: FetchingStyle }>`
  ${({ isFetching = false, fetchingStyle = 'stripe' }) =>
    isFetching &&
    css`
      position: relative;
      &::before {
        position: absolute;
        display: block;
        content: '';
        z-index: 0;

        ${fetchingStyle === 'stripe' ? stripeStyle : spinnerStyle}
      }
    `}
`
